import {connect} from 'react-redux';
import React, {Component} from 'react';
import * as APPCONFIG from "../../constants/config";
import {Button, Col, Row, Select, Spin, Modal} from "antd";
import {GoogleMap} from "../shared/googlemap";
const {benchmarkApi} = APPCONFIG;

class NewWizard extends Component {

    state = {
        cities: [],
        organisations: [],
        data: {
            currentCity: '',
            organisation: '',
            type: '0',
            name: '',
            street: '',
            streetnr: '',
            postalcode: '',
            security: '',
            pv: '0',
            led: '0',
            usageBefore: '0',
            reach: '0'
        },
        coordinates: false,
        coordinatesLoading: false,
        orgData: {
            name: '',
            street: '',
            streetnr: '',
            postalcode: '',
            city: '',
            type: '',
            customerNr: ''
        },
        cityData: {
            name: '',
            compareAs: '',
            province: ''
        },
        saving: false,
        citySaving: false,
        orgSaving: false,
        showCityModal: false,
        showOrgModal: false
    };

    empty = {

        orgData: {
            name: '',
            street: '',
            streetnr: '',
            postalcode: '',
            city: '',
            type: '',
            customerNr: ''
        },
        cityData: {
            name: '',
            compareAs: '',
            province: ''
        },
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    loadCities = async () => {
        const request = await fetch(`${benchmarkApi}cities`);
        const response = await request.json();
        await this.setStateAsync({cities: response});
    }

    loadOrganisations = async () => {
        const request = await fetch(`${benchmarkApi}organisations`);
        const response = await request.json();
        await this.setStateAsync({organisations: response});
    }

    componentDidMount = async () => {
        await this.loadCities();
        await this.loadOrganisations();
    }

    handleTypeChange = async (val) => {
        await this.setStateAsync({data : {...this.state.data, ...{type: val}}})
    }

    handleOrganisationChange = async (val) => {
        console.log("handleOrganisationChange", val)

        await this.setStateAsync({data : {...this.state.data, ...{organisation: val}}})
    }

    handleCityChange = async (val) => {
        await this.setStateAsync({data : {...this.state.data, ...{currentCity: val}}})
    }

    //function because we want to scope it
    validateElement = async (event) => {
        const valid = event.target.checkValidity();
        if(!valid) {
            event.target.classList.add('invalid');
            return;
        }
        event.target.classList.remove('invalid');

        if(!this.state.coordinates && !this.state.coordinatesLoading && this.state.data.street && this.state.data.streetnr && this.state.data.postalcode){
            await this.setStateAsync({coordinatesLoading: true});

            const request = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(this.state.data.street)}+${encodeURI(this.state.data.streetnr)}+${encodeURI(this.state.data.postalcode)}&key=${APPCONFIG.googleApiKey}`);

            const response = await request.json();
            await this.setStateAsync({coordinatesLoading: false, coordinates: response.results[0].geometry.location});
        }
    }

    validateForm = () => {
        const formLength = this.formEl.length;

        if (this.formEl.checkValidity() === false) {
            for(let i=0; i<formLength; i++) {
                const elem = this.formEl[i];
                const errorLabel = elem.parentNode.querySelector('.invalid-feedback');

                if (errorLabel && elem.nodeName.toLowerCase() !== 'button') {
                    if (!elem.validity.valid) {
                        errorLabel.textContent = elem.validationMessage;
                    } else {
                        errorLabel.textContent = '';
                    }
                }
            }

            return false;
        } else {
            for(let i=0; i<formLength; i++) {
                const elem = this.formEl[i];
                const errorLabel = elem.parentNode.querySelector('.invalid-feedback');
                if (errorLabel && elem.nodeName.toLowerCase() !== 'button') {
                    errorLabel.textContent = '';
                }
            };

            return true;
        }
    }

    submitHandler = async (event) => {
        event.preventDefault();

        if (this.validateForm()) {
            console.log(this.state.data)
        }

        this.setState({isValidated: true});



        if( this.state.data.currentCity &&
            this.state.data.organisation &&
            this.state.data.type &&
            this.state.data.name &&
            this.state.data.street &&
            this.state.data.streetnr &&
            this.state.data.postalcode &&
            this.state.data.security &&
            this.state.data.pv &&
            this.state.data.led &&
            this.state.data.usageBefore){

            await this.setStateAsync({saving: true});

            const data = {...this.state.data};
            data.latitude = this.state.coordinates.lat;
            data.longitude = this.state.coordinates.lng;
            const request = await fetch(`${benchmarkApi}locations`,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify(data)
            });
            const response = await request.json();
            console.log('submitHandler', response);

            const req2 = await fetch(`${benchmarkApi}export/location/${response[""]}`,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify(data)
            });
            console.log("req2", await req2.text());


            await this.setStateAsync({saving: false});
        }
    }

    saveCity = async () => {
        if(this.state.cityData.name && this.state.cityData.compareAs && this.state.cityData.province) {
            await this.setStateAsync({citySaving: true});

            const request = await fetch(`${benchmarkApi}cities`,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify(this.state.cityData)
            });
            const response = await request.json();
            console.log('saveCity', response);

            await this.setStateAsync({citySaving: false, cities: [], showCityModal: false, cityData: {...this.empty.cityData}});
            await this.loadCities();
            const req2 = await fetch(`${benchmarkApi}export/city/${response[""]}`);
            console.log("req2", await req2.text());
        }

    }

    saveOrg = async () => {
        if(this.state.orgData.name && this.state.orgData.street && this.state.orgData.streetnr
            && this.state.orgData.customerNr && this.state.orgData.type && this.state.orgData.city
            && this.state.orgData.postalcode) {
            await this.setStateAsync({orgSaving: true});
            const googleReq = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(this.state.orgData.street)}+${encodeURI(this.state.orgData.streetnr)}+${encodeURI(this.state.orgData.postalcode)}&key=AIzaSyANRoa_hgO7Y0dKmWObrplwFqqNpoQsrh0`);
            const googleRes = await googleReq.json();
            const coords = googleRes.results[0].geometry.location;

            const data = {...this.state.orgData};
            data.latitude = coords.lat;
            data.longitude = coords.lng;

            const request = await fetch(`${benchmarkApi}organisations`,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify(data)
            });
            const response = await request.json();
            console.log('saveOrg', response);

            await this.setStateAsync({orgSaving: false, organisation: [], showOrgModal: false, orgData: {...this.empty.orgData}});
            await this.loadOrganisations();
        }

    }

    setData = async (obj) => {
        await this.setStateAsync({data: {...this.state.data, ...obj}});
    }

    setOrgData = async (obj) => {
        await this.setStateAsync({orgData: {...this.state.orgData, ...obj}});
    }

    setCityData = async (obj) => {
        await this.setStateAsync({cityData: {...this.state.cityData, ...obj}});
    }

    showOrganisationModal = () =>  {
        this.setState({showOrgModal: true})
    }

    showCityModal = () => {
        this.setState({showCityModal: true})
    }

    render() {
        const {cities, organisations, data, coordinates, cityData, orgData} = this.state;
        if(!cities.length || !organisations.length)
            return <Spin size="large" />

        return (
            <Row>
                <Col>
                    <h1 style={{textAlign: 'center'}}>Nieuwe Locatie toevoegen</h1>
                </Col>

                <Col>
                    <form ref={form => this.formEl = form} onSubmit={this.submitHandler} >
                        <h3 style={{textAlign: 'center'}}>Basisgegevens</h3>
                        <div className="form-label-group ant-input-group">
                            <input id="inputName" name="name" type="text" className="ant-input" placeholder="Naam"
                                   required onBlur={this.validateElement} value={data.name} onChange={(val) => this.setData({name: val.target.value})}/>
                            <label htmlFor="inputName">Naam</label>
                        </div>

                        <div className="form-label-group ant-input-group">
                            <Select
                                name="type"
                                id="type"
                                className="ant-input"
                                required
                                onChange={this.handleTypeChange}
                                value={data.type}
                            >
                                <Select.Option value="0">Basisonderwijs</Select.Option>
                                <Select.Option value="1">Voortgezet onderwijs</Select.Option>
                                <Select.Option value="2">Sportclub</Select.Option>
                                <Select.Option value="3">Zorginstelling</Select.Option>
                            </Select>
                            <label htmlFor="type">Type</label>
                        </div>

                        <div className="form-label-group ant-input-group with-add">
                            <Select
                                name="organisation"
                                id="organisation"
                                className="ant-input"
                                required
                                onChange={this.handleOrganisationChange}
                                showSearch
                                optionFilterProp="children"
                                value={data.organisation}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                <Select.Option value="null">Geen Organisatie</Select.Option>
                                {
                                    organisations.map((row) => {
                                        return (
                                            <Select.Option key={row.Id} value={row.Id}>{`(${row.CustomerNr}) ${row.Name}`}</Select.Option>
                                        )
                                    })
                                }

                            </Select>
                            <label htmlFor="inputPVNo">Organisatie</label>
                            <Button type="primary" shape="circle" size="large" icon="plus" onClick={this.showOrganisationModal}/>
                        </div>

                        <div className="form-label-group ant-input-group">
                            <input id="inputSecurity" name="security" type="text" className="ant-input"
                                   placeholder="Gewenste wachtwoord" required onBlur={this.validateElement}
                                   value={data.security} onChange={(val) => this.setData({security: val.target.value})}/>
                            <label htmlFor="inputSecurity">Gewenste wachtwoord</label>
                        </div>

                        <h3 style={{textAlign: 'center'}}>Adresgegevens</h3>

                        <div className="form-label-group ant-input-group">
                            <input id="inputStreet" name="street" type="text" className="ant-input"
                                   placeholder="Straatnaam" required onBlur={this.validateElement}
                                   value={data.street} onChange={(val) => this.setData({street: val.target.value})}/>
                            <label htmlFor="inputStreet">Straatnaam</label>
                        </div>

                        <div className="form-label-group ant-input-group">
                            <input id="inputStreetNr" name="streetnr" type="text" className="ant-input"
                                   placeholder="Huisnummer" required onBlur={this.validateElement}
                                   value={data.streetnr} onChange={(val) => this.setData({streetnr: val.target.value})}/>
                            <label htmlFor="inputStreetNr">Huisnummer</label>
                        </div>

                        <div className="form-label-group ant-input-group">
                            <input id="inputPostalCode" name="postalcode" type="text" className="ant-input"
                                   placeholder="Postcode" required onBlur={this.validateElement} pattern="[0-9]{4}[A-Z]{2}"
                                   title="Postcode"
                                   value={data.postalcode} onChange={(val) => this.setData({postalcode: val.target.value})}/>
                            <label htmlFor="inputPostalCode">Postcode</label>
                        </div>

                        <div className="form-label-group ant-input-group with-add">
                            <Select
                                name="currentcity"
                                id="currentcity"
                                className="ant-input"
                                required
                                onChange={this.handleCityChange}
                                showSearch
                                optionFilterProp="children"
                                value={data.currentCity}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                <Select.Option value="">Kies een plaats</Select.Option>
                                {
                                    cities.map((row) => {
                                        return (
                                            <Select.Option key={row.Id} value={row.Id}>{row.Name}</Select.Option>
                                        )
                                    })
                                }

                            </Select>
                            <label htmlFor="inputPVNo">Plaats</label>
                            <Button type="primary" shape="circle" size="large" icon="plus" onClick={this.showCityModal}/>
                        </div>
                        {
                            coordinates && coordinates.lat && coordinates.lng ?

                                <GoogleMap marker={{...coordinates, ...{title: data.name}}} style={{width: '100%', maxWidth: '600px', height: '200px', margin: '0 auto 20px auto'}}/> : ''
                        }
                        <h3 style={{textAlign: 'center'}}>Verduurzamingsgegevens</h3>

                        <div className="form-label-group ant-input-group with-descriptor" data-descriptor="Wp">
                            <input id="inputReach" name="reach" type="number" className="ant-input"
                                   placeholder="Bereik (leerlingen/leden etc.)" min="0" step="1" required onBlur={this.validateElement}
                                   value={data.reach} onChange={(val) => this.setData({reach: val.target.value})}/>
                            <label htmlFor="inputPV">Bereik (leerlingen/leden etc.)</label>
                        </div>

                        <div className="form-label-group ant-input-group with-descriptor" data-descriptor="Wp">
                            <input id="inputPV" name="pv" type="number" className="ant-input"
                                   placeholder="Beoogde PV opwek" min="0" step="1" required onBlur={this.validateElement}
                                   value={data.pv} onChange={(val) => this.setData({pv: val.target.value})}/>
                            <label htmlFor="inputPV">Beoogd vermogen PV</label>
                        </div>

                        <div className="form-label-group ant-input-group with-descriptor" data-descriptor="kWh/jaar">
                            <input id="inputLed" name="led" type="number" className="ant-input"
                                   placeholder="Beoogde Led besparing" min="0" step="1" required
                                   onBlur={this.validateElement}
                                   value={data.led} onChange={(val) => this.setData({led: val.target.value})}/>
                            <label htmlFor="inputLed">Beoogde Led besparing</label>
                        </div>

                        <div className="form-label-group ant-input-group with-descriptor" data-descriptor="kWh/jaar">
                            <input id="inputUsageBefore" name="usageBefore" type="number" className="ant-input"
                                   placeholder="Verbruik voor verduurzaming" min="0" step="1" required
                                   onBlur={this.validateElement}
                                   value={data.usageBefore} onChange={(val) => this.setData({usageBefore: val.target.value})}/>
                            <label htmlFor="inputUsageBefore">Verbruik voor verduurzaming</label>
                        </div>

                        <Button type="primary" loading={this.state.saving} onClick={this.submitHandler}>
                            Opslaan
                        </Button>
                    </form>
                    <Modal
                        title={'Organisatie toevoegen'}
                        iconType={'plus-circle'}
                        visible={this.state.showOrgModal}
                        onCancel={() => this.setState({showOrgModal: false})}
                        footer={(
                            <Button key="submit-org" type="primary" loading={this.state.orgSaving} onClick={this.saveOrg}>
                                Opslaan
                            </Button>
                        )}
                    >
                        <div>
                            <div>
                                <div className="form-label-group ant-input-group">
                                    <input id="inputKlantNr" name="customerNr" type="text" className="ant-input" placeholder="Klantnummer"
                                           required onBlur={this.validateElement} value={orgData.customerNr} onChange={(val) => this.setOrgData({customerNr: val.target.value})}/>
                                    <label htmlFor="inputKlantNr">Klant nummer</label>
                                </div>
                                <div className="form-label-group ant-input-group">
                                    <input id="inputName" name="name" type="text" className="ant-input" placeholder="Naam"
                                           required onBlur={this.validateElement} value={orgData.name} onChange={(val) => this.setOrgData({name: val.target.value})}/>
                                    <label htmlFor="inputName">Naam</label>
                                </div>

                                <div className="form-label-group ant-input-group">
                                    <Select
                                        name="type"
                                        id="type"
                                        className="ant-input"
                                        required
                                        onChange={(val) => this.setOrgData({type: val})}
                                        value={orgData.type}
                                    >
                                        <Select.Option value="0">Stichting</Select.Option>
                                        <Select.Option value="1">Gemeente</Select.Option>
                                        <Select.Option value="2">Besloten Vennootschap</Select.Option>
                                        <Select.Option value="3">Naamloze Vennootschap</Select.Option>
                                        <Select.Option value="4">Vereniging</Select.Option>
                                    </Select>
                                    <label htmlFor="type">Type</label>
                                </div>

                                <div className="form-label-group ant-input-group">
                                    <input id="inputStreet" name="street" type="text" className="ant-input"
                                           placeholder="Straatnaam" required onBlur={this.validateElement}
                                           value={orgData.street} onChange={(val) => this.setOrgData({street: val.target.value})}/>
                                    <label htmlFor="inputStreet">Straatnaam</label>
                                </div>

                                <div className="form-label-group ant-input-group">
                                    <input id="inputStreetNr" name="streetnr" type="text" className="ant-input"
                                           placeholder="Huisnummer" required onBlur={this.validateElement}
                                           value={orgData.streetnr} onChange={(val) => this.setOrgData({streetnr: val.target.value})}/>
                                    <label htmlFor="inputStreetNr">Huisnummer</label>
                                </div>

                                <div className="form-label-group ant-input-group">
                                    <input id="inputPostalCode" name="postalcode" type="text" className="ant-input"
                                           placeholder="Postcode" required onBlur={this.validateElement} pattern="[0-9]{4}[A-Z]{2}"
                                           title="Postcode"
                                           value={orgData.postalcode} onChange={(val) => this.setOrgData({postalcode: val.target.value})}/>
                                    <label htmlFor="inputPostalCode">Postcode</label>
                                </div>

                                <div className="form-label-group ant-input-group with-add">
                                    <Select
                                        name="currentcity"
                                        id="currentcity"
                                        className="ant-input"
                                        required
                                        onChange={(val) => this.setOrgData({city: val})}
                                        showSearch
                                        optionFilterProp="children"
                                        value={orgData.city}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        <Select.Option value="">Kies een plaats</Select.Option>
                                        {
                                            cities.map((row) => {
                                                return (
                                                    <Select.Option key={row.Id} value={row.Id}>{row.Name}</Select.Option>
                                                )
                                            })
                                        }

                                    </Select>
                                    <label htmlFor="currentcity">Plaats</label>
                                    <Button type="primary" shape="circle" size="large" icon="plus" onClick={this.showCityModal}/>
                                </div>
                            </div>
                        </div>

                    </Modal>
                    <Modal
                        title={'Plaats toevoegen'}
                        iconType={'plus-circle'}
                        visible={this.state.showCityModal}
                        footer={(
                            <Button key="submit-city" type="primary" loading={this.state.citySaving} onClick={this.saveCity}>
                                Opslaan
                            </Button>
                        )}
                        onCancel={() => this.setState({showCityModal: false})}
                    >
                        <div>
                            <div>
                                <div className="form-label-group ant-input-group">
                                    <input id="inputName" name="name" type="text" className="ant-input" placeholder="Naam"
                                           required onBlur={this.validateElement} value={cityData.name} onChange={(val) => this.setCityData({name: val.target.value})}/>
                                    <label htmlFor="inputName">Naam</label>
                                </div>

                                <div className="form-label-group ant-input-group">
                                    <Select
                                        name="province"
                                        id="province"
                                        className="ant-input"
                                        required
                                        onChange={(val) => this.setCityData({province: val})}
                                        value={cityData.province}
                                    >
                                        <Select.Option value="1">Gelderland</Select.Option>
                                        <Select.Option value="2">Noord-Holland</Select.Option>
                                        <Select.Option value="3">Zuid-Holland</Select.Option>
                                        <Select.Option value="4">Drenthe</Select.Option>
                                        <Select.Option value="5">Zeeland</Select.Option>
                                        <Select.Option value="6">Utrecht</Select.Option>
                                        <Select.Option value="7">Noord-Brabant</Select.Option>
                                        <Select.Option value="8">Limburg</Select.Option>
                                        <Select.Option value="9">Flevoland</Select.Option>
                                        <Select.Option value="10">Friesland</Select.Option>
                                        <Select.Option value="11">Groningen</Select.Option>
                                        <Select.Option value="12">Overijsel</Select.Option>
                                    </Select>
                                    <label htmlFor="province">Provincie</label>
                                </div>

                                <div className="form-label-group ant-input-group">
                                    <Select
                                        name="compareAs"
                                        id="compareAs"
                                        className="ant-input"
                                        required
                                        onChange={(val) => this.setCityData({compareAs: val})}
                                        showSearch
                                        optionFilterProp="children"
                                        value={cityData.compareAs}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        <Select.Option value="null">Geen verbonden plaats</Select.Option>
                                        {
                                            cities.map((row) => {
                                                return (
                                                    <Select.Option key={row.Id} value={row.Id}>{row.Name}</Select.Option>
                                                )
                                            })
                                        }

                                    </Select>
                                    <label htmlFor="compareAs">Benchmark</label>
                                </div>
                                <div><span>Als het om een kleine plaats gaat, zorgt dit ervoor dat het in de benchmark gegroepeerd wordt met een grotere plaats. Bijv. Oosterbeek en Arnhem</span></div>
                            </div>
                        </div>

                    </Modal>
                </Col>
            </Row>);
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(NewWizard);



// WEBPACK FOOTER //
// ./src/components/baseinfo/new.js